import { Vector } from "p5";
import { getMouseOrientation } from "../../getMouseOrientation";

class Spring {
  brushSize: number;
  color: string;
  topSpeed: number;
  index: number;
  p: any;

  // Vectors
  location: Vector;
  velocity: any;
  mass: number;

  isActive: boolean;

  springConstant: number;
  damp: number;

  velx: number;
  vely: number;
  accel: number;
  force: number;

  constructor(
    color: string,
    topSpeed: number,
    mass: number,
    p: any,
    index: number
  ) {
    this.p = p;
    this.location = p.createVector(this.p.mouseX, this.p.mouseY);
    this.topSpeed = topSpeed;
    this.index = index;
    this.isActive = true;
    this.mass = mass;
    this.brushSize = 25;
    this.color = color;

    this.springConstant = 0.1;
    this.damp = 0.9;

    this.velx = 0.0; // X Velocity
    this.vely = 0.0; // Y Velocity
    this.accel = 0; // Acceleration
    this.force = 0;
  }

  setActive() {
    this.isActive = true;
  }

  setInactive() {
    this.isActive = false;
  }

  setBrushColor(color: string) {
    this.color = color;
  }

  setBrushSize(size: number) {
    this.brushSize = size;
  }

  setBrushSpeed(speed: number) {
    this.topSpeed = speed;
    this.springConstant = this.p.norm(speed, 0, 40) / 5;
  }

  getLocation() {
    return this.location;
  }

  pen(isMobile: boolean, isPortrait: boolean) {
    const mouseCoords = getMouseOrientation(
      isMobile,
      isPortrait,
      this.p.mouseX,
      this.p.mouseY,
      this.p.height
    );
    this.location.set(this.p.createVector(mouseCoords.x, mouseCoords.y));
  }

  springY(y: number) {
    this.force = -this.springConstant * (this.location.y - y); // f=-ky
    this.accel = this.force / this.mass; // Set the acceleration, f=ma == a=f/m
    this.vely = this.damp * (this.vely + this.accel); // Set the velocity
    return this.location.y + this.vely;
  }

  springX(x: number) {
    this.force = -this.springConstant * (this.location.x - x); // f=-ky
    this.accel = this.force / this.mass; // Set the acceleration, f=ma == a=f/m
    this.velx = this.damp * (this.velx + this.accel); // Set the velocity
    return this.location.x + this.velx; // Update
  }

  spring(isMobile: boolean, isPortrait: boolean) {
    const mouseCoords = getMouseOrientation(
      isMobile,
      isPortrait,
      this.p.mouseX,
      this.p.mouseY,
      this.p.height
    );
    const mouse = this.p.createVector(mouseCoords.x, mouseCoords.y);
    this.location.set(
      this.p.createVector(this.springX(mouse.x), this.springY(mouse.y))
    );
  }

  edges() {
    if (this.location.y > this.p.height - this.mass * 5) {
      this.velocity.y *= -1;
      this.location.y = this.p.height - this.mass * 5;
    }

    if (this.location.y < this.mass * 5) {
      this.velocity.y *= -1;
      this.location.y = this.mass * 5;
    }

    if (this.location.x > this.p.width - this.mass * 5) {
      this.velocity.x *= -1;
      this.location.x = this.p.width - this.mass * 5;
    }

    if (this.location.x < this.mass * 5) {
      this.velocity.x *= -1;
      this.location.x = this.mass * 5;
    }
  }
}

export default Spring;
